<template>
  <div class="container mescroll-touch">
    <div class="goPersonal" @click="toLiveHome">
      <img src="../../assets/images/icon_left1.png" />
      <span>星光</span>
    </div>
    <div class="userInfoBox">
      <div class="touxiang">
        <img src="@/assets/images/headSculpture2.png" alt="" />
      </div>
      <p class="name">{{ PersonalInfo.UserName }}</p>
      <div class="email">
        <img src="@/assets/images/email.png" alt="" />
        <span>{{ PersonalInfo.Email }}</span>
      </div>
    </div>
    <div class="menuBox" v-if="!$route.query.id || $route.query.id == userInfo.Id">
      <div class="menuItem" @click="toMyFavorite">
        <img src="@/assets/images/mydz@2x.png" alt="" />
        <span>我的点赞</span>
      </div>
      <div class="menuItem" @click="toMyCollection">
        <img src="@/assets/images/mysc@2x.png" alt="" />
        <span>我的收藏</span>
      </div>
      <div class="menuItem" @click="toMyMeeting">
        <img src="@/assets/images/myhy@2x.png" alt="" />
        <span>我的预约</span>
      </div>
      <div class="menuItem" @click="toBrowseRecords">
        <img src="@/assets/images/myjl@2x.png" alt="" />
        <span>历史记录</span>
      </div>
    </div>
    <div class="column" v-if="!$route.query.id || $route.query.id == userInfo.Id" @click="$router.push('/JNJQRcode')">
      <span>邀请码</span>
      <img src="@/assets/images/icon_right1.png" alt="" />
    </div>
    <div class="column" v-if="!$route.query.id || $route.query.id == userInfo.Id" @click="$router.push('/myInvitation')">
      <span>我的邀请</span>
      <img src="@/assets/images/icon_right1.png" alt="" />
    </div>
    <div class="column" v-if="!$route.query.id || $route.query.id == userInfo.Id" @click="$router.push('/xgPrivacyPolicy')">
      <span>隐私声明</span>
      <img src="@/assets/images/icon_right1.png" alt="" />
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from "../../common/mixin/mixins";
import { mapState, mapActions } from "vuex";
export default {
  name: 'JNJPersonal',
  data() {
    return {
      PersonalInfo: {}
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    if(this.$route.query.otherId) {
      this.miniProgramShare(this.$route.query.otherId);
      this.$axios.post('/Api/Api/Web/Customer/GetCustmAll', {
        uid: this.$route.query.otherId
      }).then(res => {
        let data = res.Data;
        this.getUserInfo(data.Id);
      })
    } else {
      this.getJJMTUserId(this.userInfo.Id);
      this.getUserInfo(this.userInfo.Id);
    }
    this.$store.commit("changeNavbarIndex", 2);
  },
  activated() {
    if(this.$route.query.otherId) {
      this.miniProgramShare(this.$route.query.otherId);
    } else {
      this.getJJMTUserId(this.userInfo.Id);
    }
    this.BuriedPoint(6, '个人中心', '', '/JNJPersonal', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    this.$store.commit('changeNavbarIndex', 2);
  },
  methods: {
    ...mapActions(['setUserInfo']),
    getUserInfo(id) {
      this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: id
      }).then(res => {
        this.PersonalInfo = res.Data;
        // this.setUserInfo({userInfo: res.Data});
        // sessionStorage.setItem("userInfo", JSON.stringify(res.Data));
      })
    },
    getJJMTUserId(userid) {
      this.$axios.get('/Api/Api/Web/Customer/GetJJMTUserId?userid=' + userid).then(res => {
        this.miniProgramShare(res.Data);
      })
    },
    miniProgramShare(userid) {
      wx.miniProgram.postMessage({
        data: {
          share: {
            title: '个人中心',
            imageUrl: process.env.VUE_APP_PERRONAL_IMG + userid,
            path: `/pages/personal/personal?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + '/xgJNJPersonal')}&otherId=${userid}&sourceType=7`,
            contentId: ''
          }
        }
      })
    },
    toMyFavorite() {
      this.BuriedPoint(1, "我的点赞", "", "/myFavorite");
      this.$router.push("/myFavorite");
    },
    toMyCollection() {
      this.BuriedPoint(1, "我的收藏", "", "/myCollection");
      this.$router.push("/myCollection");
    },
    toMyMeeting() {
      this.BuriedPoint(1, "我的预约", "", "/myMeeting");
      this.$router.push("/myMeeting");
    },
    toBrowseRecords() {
      this.BuriedPoint(1, "历史记录", "", "/browseRecords");
      this.$router.push("/browseRecords");
    },
    toLiveHome() {
      wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  padding: 20px 20px 60px;
  background-color: #F9F8F7;
  box-sizing: border-box;
  .goPersonal {
    position: absolute;
    z-index: 99;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 15px;
    img {
      display: block;
      width: 10px;
      margin-right: 6px;
    }
  }
  .userInfoBox {
    position: relative;
    margin-top: 60px;
    z-index: 9;
    width: 100%;
    background-image: url("../../assets/images/mpbg@2x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 8px;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    color: #564C47;
    .touxiang {
      position: absolute;
      left: 50%;
      top: -20px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      transform: translateX(-40px);
      box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 4px 0px;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .name {
      margin-top: 65px;
      font-size: 16px;
      font-weight: bold;
    }
    .email {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 6px;
      margin-bottom: 15px;
      img {
        display: block;
        width: 20px;
        margin-right: 4px;
      }
    }
  }
  .menuBox {
    display: flex;
    margin-top: 20px;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    padding: 15px 5px;
    .menuItem {
      width: 25%;
      text-align: center;
      img {
        display: block;
        width: 50px;
        margin: 0 auto 7px;
      }
      span {
        font-size: 14px;
        color: #564C47;
      }
    }
  }
  .column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    margin-top: 20px;
    padding: 0 18px;
    img {
      display: block;
      width: 10px;
    }
    span {
      font-size: 14px;
      color: #564C47;
    }
  }
}
.container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 110px;
  background-color: #EB1701;
  z-index: 1;
}
</style>